import { defineLazyComponent } from "../defineLazyComponent";

/**
 * Async-loaded wrapper around MapContainer.vue, which pulls in maplibre-gl.
 * Always import this instead of MapContainer.vue directly, so the map
 * library stays in its own chunk and isn't included in the main bundle.
 */
export const MapContainerAsync = defineLazyComponent(
  () => import("./MapContainer.vue"),
);
